"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelionRebalanced = void 0;
var Card_1 = require("../../Card");
var Tags_1 = require("../../Tags");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var CardType_1 = require("../../CardType");
var CardRenderer_1 = require("../../render/CardRenderer");
var Size_1 = require("../../render/Size");
var HelionRebalanced = (function (_super) {
    __extends(HelionRebalanced, _super);
    function HelionRebalanced() {
        return _super.call(this, {
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.HELION_REBALANCED,
            tags: [Tags_1.Tags.SPACE],
            startingMegaCredits: 40,
            metadata: {
                cardNumber: 'R18',
                description: 'You start with 4 heat production and 40 M€.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.heat(4).digit; }).nbsp.megacredits(40);
                    b.corpBox('effect', function (ce) {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect('You may use heat as MC. You may not use M€ as heat.', function (eb) {
                            eb.startEffect.text('x').heat(1).equals().megacredits(0).multiplier;
                        });
                        ce.effect('You may always spend 7 heat, instead of 8, to raise a temperature.', function (eb) {
                            eb.heat(7).digit.startAction.temperature(1);
                        });
                    });
                }),
            },
        }) || this;
    }
    HelionRebalanced.prototype.play = function (player) {
        player.canUseHeatAsMegaCredits = true;
        player.heatNeededForTemperature = 7;
        player.addProduction(Resources_1.Resources.HEAT, 4);
        return undefined;
    };
    return HelionRebalanced;
}(Card_1.Card));
exports.HelionRebalanced = HelionRebalanced;
//# sourceMappingURL=HelionRebalanced.js.map